<template>
  <thead class="sticky top-0 z-10">
    <slot></slot>
  </thead>
</template>
